var _rect, _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16,
    height: 19,
    rx: 2,
    fill: "#A4A4A8",
    stroke: "#A4A4A8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 4C5 3.44772 5.44772 3 6 3C6.55228 3 7 3.44772 7 4V17C7 17.5523 6.55228 18 6 18C5.44772 18 5 17.5523 5 17V4Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 7,
    r: 2.5,
    fill: "#A4A4A8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 7,
    r: 2.5,
    fill: "#A4A4A8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 7,
    r: 2.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 7,
    r: 2.5,
    stroke: "#A4A4A8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 2.5,
    fill: "#A4A4A8"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 2.5,
    fill: "#A4A4A8"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 2.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 2.5,
    stroke: "#A4A4A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoControl);
export default __webpack_public_path__ + "static/media/ico-control.69a42f2739c21e30eafcd8915878e766.svg";
export { ForwardRef as ReactComponent };